module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Tobel-Taegerschen_COA-3895e7aa82d7eb2c32a0b5c8c05f5c64.svg";